import { createContext } from "react";

export const TaskFiredDataStruct = {
  logTypeId: "",
  employeeId: "",
  employeeName: "",
  taskId: "",
};

const TaskFiredData = createContext({
  taskFiredData: { ...TaskFiredDataStruct },
  setTaskFiredData: (taskData) => {},
});

export const TaskFiredDataContext = {
  TaskFiredDataContext: TaskFiredData,
};
